import { EyeIcon, EyeOffIcon } from 'lucide-react'
import PropTypes from 'prop-types'
import { useState } from 'react'

import { Input } from '@/components/elements/input'

/**
 *
 * PasswordInput
 *
 */
const PasswordInput = ({ ...rest }) => {
  // State
  const [reveal, setReveal] = useState(false)

  return (
    <div className="relative mt-1">
      <Input type={reveal ? 'text' : 'password'} {...rest} autoComplete="off" />
      <button
        type="button"
        data-testid="password-visibility-toggle"
        onClick={() => setReveal(!reveal)}
        tabIndex={-1}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
        aria-label={reveal ? 'Hide password' : 'Show password'}
      >
        {reveal ? <EyeOffIcon className="h-5 w-5" /> : <EyeIcon className="h-5 w-5" />}
      </button>
    </div>
  )
}

PasswordInput.propTypes = {
  className: PropTypes.string,
  inputStyles: PropTypes.string,
  endIcon: PropTypes.object,
  error: PropTypes.string,
  fullWidth: PropTypes.bool,
  icon: PropTypes.object,
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  renderIconStyles: PropTypes.string,
  value: PropTypes.string,
}

export default PasswordInput
